import React from 'react'

import Button from '../../components/form/Button'

const FloatingSubmitButton: React.FC<{ children: string, disabled: boolean }> = ({ children, disabled }) => {
  return (
    <>
      <Button className='fixed sm:hidden box-content bottom-2 left-4 w-[85%]' size='lg' type='submit' disabled={disabled}>
        {children}
      </Button>
      <Button className='hidden sticky sm:block w-[450px] mx-auto bottom-2' size='lg' type='submit' disabled={disabled}>
        {children}
      </Button>
    </>
  )
}

export default FloatingSubmitButton
